import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { showToast } from "vant";
import { decryptData, encryptData } from "./crypto";
import { Response } from "@/types/common";
import { useUserStore } from "@/stores/user";
import { i18n } from "@/i18n/index";

const { t } = i18n.global;
export const baseURL = process.env.VUE_APP_BASE_API;
export const tenantId = localStorage.getItem('tenantId') ?? "000000";
const clientId = localStorage.getItem('clientId') ?? "1";

const _axios: AxiosInstance = axios.create({
  baseURL: baseURL + "/app",
  headers: {
    "Content-Type": "application/json",
    "clientid": clientId,
    'tenant-id' : tenantId
  },
  timeout: 50 * 1000,
});

_axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers["authorization"] = `Bearer ${token}`;
    config.headers["satoken"] = token;
  }

  const language = document.querySelector("html")?.getAttribute("language");
  if (language) {
    config.headers["language"] = language;
  }

  const lang = document.querySelector("html")?.getAttribute("lang");
  if (lang) {
    config.headers["lang"] = lang;
  }

  return config;
});

_axios.interceptors.response.use((response: AxiosResponse) => {
  if (response.status === 200) {
    if (response.data.code == 200) {
      // const encryptedData = response.data.data;

      // if (typeof encryptedData === "string") {
      //   const decrypted = decryptData(encryptedData);
      //   response.data.data = decrypted;
      // }
      // Assign the data property to the response for consistency
      return Promise.resolve(response.data);
    } else if (response.data.code == 401) {
       const popupFn = (window as any).openLoginPopup;
      popupFn?.(1);
       location.replace("#/")
       localStorage.setItem('token', '')
          
      const userStore = useUserStore();
      userStore.resetUserData();
      return Promise.reject({ handled: true, msg: t(response.data.msg), code: 401 });
    } else {
      return Promise.reject(t(response.data.msg ) || "Erro do sistema");
    }
  } else {
    showToast("Erro do sistema");
    return Promise.reject(response);
  }
});

export const get = (url: string, params?: any): Promise<Response> =>
  _axios.get(url, { params });

export const post = (url: string, params?: any): Promise<Response> =>
  _axios.post(url, params);

// export const post = (url: string, params?: any) => {
//   const encryptedParams = encryptData(params || {});
//   return _axios.post(url, { data: encryptedParams });
// };
